import { render, staticRenderFns } from "./BeheerOverzicht.vue?vue&type=template&id=4ba03ece&"
import script from "./BeheerOverzicht.vue?vue&type=script&lang=js&"
export * from "./BeheerOverzicht.vue?vue&type=script&lang=js&"
import style0 from "./BeheerOverzicht.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
